import { useNavigate } from 'react-router';
import { Icon } from '@/kit/Icon';
import './ApplicationTestingDashboard.scss';

/**
 * The Application Testing menu shared by its pages (dashboard and ticket list): the current page is highlighted.
 */
export function ApplicationTestingSidebar({ active }: { active: 'dashboard' | 'tickets' }) {
  const navigate = useNavigate();
  const item = (key: 'dashboard' | 'tickets') => `atd-nav${active === key ? ' active' : ''}`;

  return (
    <nav className="atd-sidebar" aria-label="Application Testing">
      <button
        type="button"
        className={item('dashboard')}
        aria-current={active === 'dashboard' ? 'page' : undefined}
        onClick={() => navigate('/home/application-testing/dashboard')}
      >
        <Icon name="space_dashboard" outlined />
        Dashboard
      </button>
      <button
        type="button"
        className={item('tickets')}
        aria-current={active === 'tickets' ? 'page' : undefined}
        onClick={() => navigate('/home/application-testing')}
      >
        <Icon name="description" outlined />
        All Tickets
      </button>
    </nav>
  );
}
